export var ClassificationEnum;
(function (ClassificationEnum) {
    ClassificationEnum["Star"] = "Star";
    ClassificationEnum["Planet"] = "Planet";
    ClassificationEnum["DwarfPlanet"] = "Dwarf Planet";
    ClassificationEnum["Moon"] = "Moon";
    ClassificationEnum["Satellite"] = "Satellite";
})(ClassificationEnum || (ClassificationEnum = {}));
